
import { styled } from '@mui/material/styles';

const Hr = styled('hr')({});

export default Hr;